<template lang="pug">
	section
		p.mb-5
			| Save time by skipping steps you’ve already completed.
		section.radio-wrap
			.radio
				sfc-radio(v-model="csjourney" :radio-value="`no_saving`" label="I haven't started saving at all" @click="next('no_saving')" name="no_saving")
		section.radio-wrap
			.radio
				sfc-radio(v-model="csjourney" :radio-value="`saving_without_529_plan`" label="I'm setting money aside, but not with a 529 plan" @click="next('saving_without_529_plan')" name="saving_without_529_plan")
		section.radio-wrap
			.radio
				sfc-radio(v-model="csjourney" :radio-value="`saving_with_a_529_plan`" label="I'm saving with a 529 plan for at least one child" @click="next('saving_with_a_529_plan')" name="saving_with_a_529_plan")
		.continue-button
			sfc-button.mr-4(:blue="false" :backArrow="true" @click="back()")
</template>

<script>
import SfcRadio from '@/common/components/inputs/v2/radio'
import SfcButton from '@/common/components/sfc-button'
import SfcTrackingService from "@/lib/sfc-tracking-service"

export default {

	components:{
		SfcButton,
		SfcRadio
	},

	props: {
	},

	data() {
		return {
			errors: {
			},
			csjourney: undefined,
			progressLength: 0
		}
	},

	methods: {
		next(value){
			this.$store.commit('updateCurrentCsjourney', value)

			let answer = value.replaceAll("_", " ");
			SfcTrackingService.trackAnalyticsAction("Savings Center Onboarding", "Journey - next", answer, 0)

			this.$emit('next', this.progressLength, "Are you interested in learning how to grow your college savings with gifting?", "sfc-college-savings-gifting")
		},
		back(){
			this.$emit('next', 0, "What is your state of residence?", "sfc-who-are-you-saving-for")
		},
	}

}
</script>
